var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#434343"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.622 9.27c.843.226 1.507.89 1.733 1.733.421 1.538.405 4.745.405 4.745s0 3.19-.405 4.73a2.463 2.463 0 0 1-1.733 1.732c-1.538.405-7.693.405-7.693.405s-6.138 0-7.693-.42a2.463 2.463 0 0 1-1.733-1.734c-.405-1.522-.405-4.729-.405-4.729s0-3.19.405-4.73a2.514 2.514 0 0 1 1.733-1.748c1.539-.405 7.693-.405 7.693-.405s6.155 0 7.693.42Zm-4.535 6.35-5.118 2.947v-5.895l5.118 2.947Z",
    fill: "#fff"
  })));
};
export default SvgYoutube;